import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchPage } from "../lib/api";
import SEO from "../components/SEO";
import { Loader2 } from "lucide-react";
import { T } from "../lib/autoTranslate";

const CustomPage = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    fetchPage(slug)
      .then((data) => setPage(data))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <div className="flex justify-center py-24">
        <Loader2 className="animate-spin text-[var(--ri-red)]" size={32} />
      </div>
    );
  }

  if (notFound || !page) {
    return (
      <div className="section text-center">
        <p className="text-[18px] text-[var(--ri-ink-soft)]">Page not found.</p>
      </div>
    );
  }

  return (
    <div className="pt-16">
      <SEO
        title={page.seo_title || page.title}
        description={page.seo_description || ""}
        path={`/page/${page.slug}`}
        image={page.seo_og_image || undefined}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: page.title,
          url: `${window.location.origin}/page/${page.slug}`,
        }}
      />
      <section className="section-tight bg-[var(--ri-cream)]">
        <div className="container-x max-w-[760px]">
          <h1 className="font-serif-display text-[32px] md:text-[42px] leading-[1.08]"><T>{page.title}</T></h1>

          {page.content_blocks && page.content_blocks.length > 0 && (
            <div className="mt-10 space-y-8">
              {page.content_blocks.map((block, i) =>
                block.type === "image" && block.image ? (
                  <figure
                    key={i}
                    className={
                      block.size === "small"
                        ? "max-w-[320px] mx-auto"
                        : block.size === "medium"
                        ? "max-w-[560px] mx-auto"
                        : ""
                    }
                  >
                    <img src={block.image} alt={block.caption || page.title} loading="lazy" className="w-full rounded-2xl object-cover max-h-[520px]" />
                    {block.caption && (
                      <figcaption className="mt-3 text-[13px] text-[var(--ri-muted)] text-center"><T>{block.caption}</T></figcaption>
                    )}
                  </figure>
                ) : block.text ? (
                  <div key={i} className="space-y-6 text-[17px] leading-[1.8] text-[var(--ri-ink-soft)] rte-content">
                    {/<[a-z][\s\S]*>/i.test(block.text) ? (
                      <div dangerouslySetInnerHTML={{ __html: block.text }} />
                    ) : (
                      block.text.split(/\n{2,}/).filter(Boolean).map((para, j) => (
                        <p key={j}><T>{para}</T></p>
                      ))
                    )}
                  </div>
                ) : null
              )}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default CustomPage;
